import { useState } from "react";
import LoginForm from "./LoginForm";
import SignupForm from "./SignupForm";
// import Dashboard from "./dashboard";
import PersonalDetailsForm from "./components/personalDetailsForm";
import {BrowserRouter as Router, Routes, Route, Navigate} from "react-router-dom";
// import './App-v1.css';
import SubmittedMessage from "./components/submittedMessage";


const App = () => {
  // const [isLogin, setIsLogin] = useState(true); 
  const [userData, setUserData] = useState(null); // Initially show the login form
  const [showPassword, setShowPassword] = useState(false);

  function handleTogglePassword() {
    setShowPassword(!showPassword);
  }

//   const handleLogout = () => {
//     localStorage.removeItem("userData"); // Clear stored user data
//     window.location.href = "/login"; // Redirect to login page
// };

  // const handleSwitchToSignup = () => {
  //   setIsLogin(false); // Switch to the signup form
  // };

  // const handleCreateAccount = () => {
  //   setIsLogin(true); // Switch back to the login form after account creation
  // };

 

  return (
    // <>
    //   {userData ? <PersonalDetailsForm userData={userData} /> : (

    // <div className="">
    //   <div className="">
    //     { isLogin ? (
    //       <LoginForm onSwitchToSignup={handleSwitchToSignup} setUserData={setUserData} onHandleToggle={handleTogglePassword} showPassword={showPassword}/>
    //     ) : (
    //       <SignupForm onCreateAccount={handleCreateAccount} onHandleToggle={handleTogglePassword} showPassword={showPassword}/>
    //     )}
    //     </div>
    //   </div>
    //   )}
    // </>
//       <>
//          <Router>
//       <Routes>
//         {/* Redirect root path to login */}
//         <Route path="/" element={<Navigate to="/login" />} />

//         {/* Login Route */}
//         <Route path="/login" element={
//           userData ? <Navigate to="/details" /> : 
//           <LoginForm setUserData={setUserData} onHandleToggle={handleTogglePassword} showPassword={showPassword}   />
//         } />

//         {/* Signup Route */}
//         <Route path="/signup" element={
//           userData ? <Navigate to="/details" /> : 
//           <SignupForm onHandleToggle={handleTogglePassword} showPassword={showPassword} />
//         } />

//         {/* Show message if the application is already submitted */}
//         <Route path="/submitted" element={<SubmittedMessage />} />

// {/* Protected route: If the user has already submitted, redirect to the message */}
//       <Route path="/details" element={
//         userData 
//         ? <PersonalDetailsForm userData={userData} onHandleLogout={handleLogout} /> 
//         : <Navigate to="/login" />
//       } />
//         {/* Catch-all Route for 404 Not Found */}
//         <Route path="*" element={<Navigate to="/login" />} />
//       </Routes>
//     </Router>
//       </>
<Router>
  <Routes>
  {/* Redirect root path to login */}
  <Route path="/" element={<Navigate to="/login" />} />

  {/* Login Route */}
  {/* <Route path="/login" element={
    userData 
      ? (userData.hasSubmitted ? <Navigate to="/submitted" /> : <Navigate to="/details" />) 
      : <LoginForm setUserData={setUserData} onHandleToggle={handleTogglePassword} showPassword={showPassword} />
  } /> */}
  <Route path="/login" element={
  <LoginForm 
    setUserData={setUserData} 
    onHandleToggle={handleTogglePassword} 
    showPassword={showPassword} 
   
  />
} />

  {/* Signup Route */}
  {/* <Route path="/signup" element={
    userData 
      ? <Navigate to="/details" /> 
      : <SignupForm onHandleToggle={handleTogglePassword} showPassword={showPassword} />
  } /> */}

<Route path="/signup" element={
    userData && !userData.hasSubmitted
      ? <Navigate to="/details" />
      : <SignupForm onHandleToggle={handleTogglePassword} showPassword={showPassword} />
  } />


  {/* Show message if the application is already submitted */}
  <Route path="/submitted" element={<SubmittedMessage />} />

  {/* Protected route: If the user has already submitted, redirect to the message */}
  <Route path="/details" element={
    userData 
      ? (userData.hasSubmitted ? <Navigate to="/submitted" /> : <PersonalDetailsForm userData={userData} />) 
      : <Navigate to="/login" />
  } />

  {/* Catch-all Route for 404 Not Found */}
  <Route path="*" element={<Navigate to="/login" />} />
  </Routes>
</Router>

    
  );
};

export default App;

// {/* <div className="container">
//       <div className="form-container">
//       {userData ? (
//         <PersonalDetailsForm userData={userData} /> ) : isLogin ? (
//           <LoginForm onSwitchToSignup={handleSwitchToSignup} setUserData={setUserData} onHandleToggle={handleTogglePassword} showPassword={showPassword}/>
//         ) : (
//           <SignupForm onCreateAccount={handleCreateAccount} onHandleToggle={handleTogglePassword} showPassword={showPassword}/>
//         )}
//       </div>
//     </div> */}
